export interface MapConfig {
  bingMapKey: string;
  bingMapRestUrl: string;
}

const BaseMapConfig = {
  bingMapRestUrl: 'https://dev.virtualearth.net'
};

export const DevMapConfig: MapConfig = {
  ...BaseMapConfig,
  bingMapKey: 'AjmXEoj2kXbT1mNhn61mUN4tmxbOO0qPBVlUcgz7HvrJVmuUPb-yXsmDI5LYydD5'
};

export const ProdMapConfig: MapConfig = {
  ...BaseMapConfig,
  bingMapKey: 'AjNaemJoYOsLOPj2Ja2Y0_OVApNy77ImtERpJo9wy30cF8E3T5tJ05v35BuWqEtf'
};
